
const digest = 'b24f16273a3710726e84e1c0a3bbea0898fb71b4ca1503c3ba84ea0a9d5ea15b';
const css = `._editLink_iw52x_1 {
  box-sizing: border-box;
  padding: var(--spacer-2);
  display: flex;
  flex-direction: column;
  gap: var(--spacer-3);
}
._label_iw52x_8 {
  display: flex;
  flex-direction: column;
  gap: var(--spacer-1);
}
._labelName_iw52x_13 {
  font-size: 11px;
  color: var(--theme-tertiary-text);
}
._input_iw52x_17 {
  &::placeholder {
    color: var(--theme-input-placeholder);
  }
}
._input_iw52x_17[type='text'] {
  text-overflow: ellipsis;
}
._inputTextarea_iw52x_25 {
  field-sizing: content;
}

._imagePreview_iw52x_29 {
  display: flex;
  flex-direction: column;
  gap: var(--spacer-2);
}

._previewImage_iw52x_35 {
  max-width: 200px;
  max-height: 150px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid var(--theme-border-color);
}

._uploadSection_iw52x_43 {
  display: flex;
  flex-direction: column;
  gap: var(--spacer-2);
}

._uploadStatus_iw52x_49 {
  font-size: 12px;
  color: var(--theme-secondary-text);
  font-style: italic;
}

._uploadError_iw52x_55 {
  font-size: 12px;
  color: var(--theme-error-text);
}
._removeImageButton_iw52x_59 {
  --aha-button--color: var(--theme-alert-danger);
  color: var(--theme-alert-danger-text);
}
._buttonText_iw52x_63 {
  display: flex;
  gap: var(--spacer-1);
  align-items: center;
  svg path {
    fill: currentColor;
  }
}
._imageSizeOptionCheckMark_iw52x_71 {
  color: var(--theme-link-text);
}
._imageSizeOption_iw52x_71 {
  padding: var(--aha-menu-item--padding);
  justify-content: space-between;
  gap: var(--spacer-8);
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"editLink":"_editLink_iw52x_1","label":"_label_iw52x_8","labelName":"_labelName_iw52x_13","input":"_input_iw52x_17","inputTextarea":"_inputTextarea_iw52x_25","imagePreview":"_imagePreview_iw52x_29","previewImage":"_previewImage_iw52x_35","uploadSection":"_uploadSection_iw52x_43","uploadStatus":"_uploadStatus_iw52x_49","uploadError":"_uploadError_iw52x_55","removeImageButton":"_removeImageButton_iw52x_59","buttonText":"_buttonText_iw52x_63","imageSizeOptionCheckMark":"_imageSizeOptionCheckMark_iw52x_71","imageSizeOption":"_imageSizeOption_iw52x_71"};
export { css, digest };
  